<template>
  <div class="popup-main">
    <el-dialog
      title="跟进记录"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <e-form ref="refForm" :config="formConfig" :column="formColumn" :data.sync="selfDetail" />
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :max-height="tableConfig.maxHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :row-config="tableConfig.rowConfig"
          :columns="tableColumn"
          :data="selfDetail.list"
          :show-footer="!!selfDetail.list.length"
        >
          <!-- slot_default -->
          <template #default_create_date="{ row }">
            {{ row.create_date.slice(0, 10) }}
          </template>
          <template #default_type="{ row }">
            <div class="flex flex-x-between flex-y-center p-x-5">
              <div class="flex flex-y-center">
                <span v-if="row.bill_code" :class="row.version === 1 ? 'c-gray-light' : 'c-red'"
                  >({{ row.version === 1 ? '旧' : '新' }})</span
                >
                <el-link
                  v-if="row.bill_code"
                  class="m-l-5"
                  type="primary"
                  @click="jumpSaleVerifyDetail(row)"
                >
                  {{ row.bill_code }}
                </el-link>
              </div>
              <span class="c-gray">{{ row.type }}</span>
            </div>
          </template>
          <template #default_jie_tu_list="{ row }">
            <e-upload-image v-if="row.jie_tu_list" disabled :list.sync="row.jie_tu_list" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" type="success" @click="customerFollowUpAdd">写跟进</el-button>
        <el-button size="mini" @click="popupCancel">关闭</el-button>
      </div>
    </el-dialog>
    <PopupVerifyDo v-if="isShowPopupVerifyDo" :show.sync="isShowPopupVerifyDo" :billId="billId" />
    <PopupCustomerFollowUpAdd
      v-if="isShowPopupCustomerFollowUpAdd"
      :show.sync="isShowPopupCustomerFollowUpAdd"
      :detail="selfDetail"
      @success="onFollowUpSuccess"
    />
  </div>
</template>

<script>
export default {
  components: {
    PopupVerifyDo: () => import('@/views/new/verify/common/popup-verify-do'),
    PopupCustomerFollowUpAdd: () => import('@/views/new/customer/user/popup-customer-follow-up-add')
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfDetail: {
        formData: {
          gen_jin_date_tian_shu: '', // 距上次跟进
          customer_name: '', // 客户企业名称
          history_level: '', // 客户等级
          suo_shu_hang_ye: '', // 所属行业
          address: '', // 客户地址
          linkman: '', // 联系人
          phone: '', // 联系人电话
          sales_man: '' // 所属业务
        },
        list: []
      },
      formConfig: {
        inline: true,
        width: '240px'
      },
      formColumn: [
        {
          type: 'text',
          title: '距上次跟进',
          field: 'gen_jin_date_tian_shu',
          width: '150px',
          disabled: true,
          placeholder: ' ',
          suffix: '天'
        },
        {
          type: 'text',
          title: '客户企业名称',
          field: 'customer_name',
          width: '330px',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '客户等级',
          field: 'history_level',
          width: '150px',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '联系人',
          field: 'linkman',
          width: '150px',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '联系人电话',
          field: 'phone',
          width: '180px',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '所属业务',
          field: 'sales_man',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '所属行业',
          field: 'suo_shu_hang_ye',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '客户地址',
          field: 'address',
          width: '480px',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '成交金额',
          field: 'cheng_jiao_jin_e',
          disabled: true,
          placeholder: ' ',
          suffix: '元'
        },
        {
          type: 'text',
          title: '成交单数',
          field: 'cheng_jiao_dan_shu',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '成交利润',
          field: 'cheng_jiao_li_run',
          disabled: true,
          placeholder: ' ',
          suffix: '元'
        },
        {
          type: 'text',
          title: '成交利润率',
          field: 'cheng_jiao_li_run_lv',
          disabled: true,
          placeholder: ' ',
          suffix: '%'
        },
        {
          type: 'text',
          title: '报价金额',
          field: 'bao_jia_jin_e',
          disabled: true,
          placeholder: ' ',
          suffix: '元'
        },
        {
          type: 'text',
          title: '报价单数',
          field: 'bao_jia_dan_shu',
          disabled: true,
          placeholder: ' '
        },
        {
          type: 'text',
          title: '报价利润',
          field: 'bao_jia_li_run',
          disabled: true,
          placeholder: ' ',
          suffix: '元'
        },
        {
          type: 'text',
          title: '报价利润率',
          field: 'bao_jia_li_run_lv',
          disabled: true,
          placeholder: ' ',
          suffix: '%'
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '跟进时间',
          field: 'create_date',
          slots: { default: 'default_create_date' }
        },
        {
          title: '跟进类型',
          field: 'type',
          slots: { default: 'default_type' }
        },
        {
          title: '跟进备注',
          field: 'bei_zhu'
        },
        {
          title: '跟进截图',
          field: 'jie_tu_list',
          slots: { default: 'default_jie_tu_list' }
        },
        {
          title: '操作人员',
          field: 'do_man',
          width: 120
        }
      ],
      billId: null,
      isShowPopupVerifyDo: false,
      isShowPopupCustomerFollowUpAdd: false
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        maxHeight: 450
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show

    this.initDetailData()
  },
  methods: {
    // 获取-详情数据
    initDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/keHuGenZong/detail',
        params: {
          id: this.id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let result = this.$util.deepCopy(res.data.data)
            if (result.address_list_str && result.address_list_str.length) {
              result.address = `${result.address_list_str.join('')}${result.address}`
            } else {
              result.address = ''
            }
            this.selfDetail = result
          }
        })
        .catch(() => {})
    },
    // 销售核算单详情
    jumpSaleVerifyDetail(row) {
      if (row.version === 1) {
        window.open(`/sale/verify/detail?id=${row.bill_id}`, '_blank')
      }
      if (row.version === 2) {
        this.billId = row.bill_id
        this.isShowPopupVerifyDo = true
      }
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 打开写跟进弹窗
    customerFollowUpAdd() {
      this.isShowPopupCustomerFollowUpAdd = true
    },
    // 写跟进保存成功回调
    onFollowUpSuccess() {
      this.initDetailData()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: #333;
    background-color: #fafafa;
  }
  /deep/ .el-input__prefix,
  /deep/ .el-input__suffix {
    color: #333;
  }
}
</style>
